import axiosTuri from "../../axiosTuri";

// Get All Cooperators
export const getAllCooperators = async () => {
  const res = await axiosTuri.get(`cooperators/`);
  if (res.data.status === "success") {
    return res.data;
  }
};

// Store Cooperator with photo
export const createCooperator = async (data) => {
  console.log(data);
  const formData = new FormData();
  for (const key in data) {
    formData.append(key, data[key]);
  }

  const res = await axiosTuri.post(`cooperators/`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  if (res.data.status === "success") {
    return res.data;
  }
};

// Update Cooperator with photo
export const updateCooperator = async ({ id, data }) => {
  const res = await axiosTuri.post(`cooperators/${id}?_method=PUT`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  if (res.data.status === "success") {
    return res.data;
  }
};

// Delete Cooperator
export const deleteCooperator = async (id) => {
  const res = await axiosTuri.delete(`cooperators/${id}`);
  if (res.data.status === "success") {
    return res.data;
  }
};

// --- NEW FUNCTIONS ---

// Get All Rules
export const getAllRules = async () => {
  // Assuming axiosTuri is configured with the base URL (e.g., http://localhost:8000/api)
  // Route defined as: GET /api/cooperators/meta/all-rules
  const res = await axiosTuri.get(`cooperators/meta/all-rules`);
  // You might want to add more robust error handling or data extraction here
  // based on your API's ResponseHelper structure.
  // For now, returning the whole res.data if status is success.
  if (res.data && res.data.status === "success") {
    return res.data; // Or res.data.data if your ResponseHelper nests the payload
  }
  // Potentially return null, an empty array, or throw an error if not successful
  // console.error("Failed to fetch rules or status not success", res.data);
  // return null; // Or throw new Error('Failed to fetch rules');
};

// Get All Permissions
export const getAllPermissions = async () => {
  // Route defined as: GET /api/cooperators/meta/all-permissions
  const res = await axiosTuri.get(`cooperators/meta/all-permissions`);
  if (res.data && res.data.status === "success") {
    return res.data; // Or res.data.data
  }
  // console.error("Failed to fetch permissions or status not success", res.data);
  // return null; // Or throw new Error('Failed to fetch permissions');
};
